module.exports = __webpack_public_path__ + "img/info-circle-svgrepo-com.98dd24be.svg";